export default "/themes/nutristopa/assets/img/acidification.png";